import { render, staticRenderFns } from "./EventBox.vue?vue&type=template&id=6c364728&scoped=true&"
import script from "./EventBox.vue?vue&type=script&lang=js&"
export * from "./EventBox.vue?vue&type=script&lang=js&"
import style0 from "./EventBox.vue?vue&type=style&index=0&id=6c364728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c364728",
  null
  
)

export default component.exports